import React from 'react';
import { TablePagination } from '@mui/material';

import { paginationPropsPropTypesShape } from '../propTypes';

import PaginationActions from './PaginationActions';

import styles from '../sortableTable.module.scss';

const TablePaginationSection = ({ combinedPaginationProps }) => {
  const { onChangePage: onPageChange, page, count, rowsPerPage, disabled } = combinedPaginationProps;

  const getLabelDisplayedRows = ({ from, to, count }) => {
    if (rowsPerPage === -1) {
      return `All ${count} rows`;
    } else {
      return `${from}-${to} of ${count}`;
    }
  };

  return (
    <TablePagination
      className={styles.tablePagination}
      rowsPerPageOptions={combinedPaginationProps.rowsPerPageOptions}
      component="div"
      rowsPerPage={rowsPerPage}
      count={count}
      page={page}
      onPageChange={combinedPaginationProps.onChangePage}
      onRowsPerPageChange={combinedPaginationProps.onChangeRowsPerPage}
      labelDisplayedRows={getLabelDisplayedRows}
      ActionsComponent={() => (
        <PaginationActions
          count={count}
          page={page}
          onPageChange={onPageChange}
          disabled={disabled}
          rowsPerPage={rowsPerPage}
        />
      )}
    />
  );
};

TablePaginationSection.propTypes = {
  combinedPaginationProps: paginationPropsPropTypesShape,
};

export default TablePaginationSection;
